import type { Template } from "@/types";

export const PO_06_H5_V1: Template[] = [
{
    id: "po-06-h5v1-01",
    name: "PO 01 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_01.png",
    size: [1217, 851],
    style: {},
        slots: [
            { id: "1", x: 37, y: 157, width: 344, height: 538, rotation: 0, imageRotation: 0 },           
            { id: "2", x: 389, y: 157, width: 188, height: 129, rotation: 0, imageRotation: 0 },
            { id: "3", x: 389, y: 294, width: 188, height: 129, rotation: 0, imageRotation: 0 },
            { id: "4", x: 389, y: 431, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "5", x: 389, y: 567, width: 188, height: 128, rotation: 0, imageRotation: 0 },
            { id: "6", x: 651, y: 240, width: 522, height: 370, rotation: 0, imageRotation: 0 }
        ],
},

{
    id: "po-06-h5v1-02",
    name: "PO 02 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_02.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 56, y: 253, width: 233, height: 344, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 297, y: 253, width: 260, height: 168, rotation: 0, imageRotation: 0 },
        { id: "3", x: 297, y: 429, width: 260, height: 168, rotation: 0, imageRotation: 0 },
        { id: "4", x: 663, y: 183, width: 489, height: 318, rotation: 0, imageRotation: 0 },
        { id: "5", x: 663, y: 509, width: 240, height: 158, rotation: 0, imageRotation: 0 },
        { id: "6", x: 911, y: 509, width: 240, height: 158, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-03",
    name: "PO 03 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_03.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 44, y: 240, width: 522, height: 370, rotation: 0, imageRotation: 0 },
        { id: "2", x: 640, y: 157, width: 344, height: 539, rotation: 0, imageRotation: 0 },
        { id: "3", x: 992, y: 157, width: 188, height: 129, rotation: 0, imageRotation: 0 },
        { id: "4", x: 992, y: 294, width: 188, height: 129, rotation: 0, imageRotation: 0 },
        { id: "5", x: 992, y: 431, width: 188, height: 129, rotation: 0, imageRotation: 0 },
        { id: "6", x: 992, y: 568, width: 188, height: 128, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-04",
    name: "PO 04 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_04.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 85, y: 142, width: 432, height: 274, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 85, y: 424, width: 212, height: 139, rotation: 0, imageRotation: 0 },
        { id: "3", x: 305, y: 424, width: 212, height: 139, rotation: 0, imageRotation: 0 },
        { id: "4", x: 85, y: 571, width: 212, height: 138, rotation: 0, imageRotation: 0 },
        { id: "5", x: 305, y: 571, width: 212, height: 138, rotation: 0, imageRotation: 0 },
        { id: "6", x: 718, y: 141, width: 389, height: 567, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-05",
    name: "PO 05 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_05.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 57, y: 252, width: 494, height: 345, rotation: 0, imageRotation: 0 },
        { id: "2", x: 674, y: 559, width: 154, height: 224, rotation: 0, imageRotation: 0 },
        { id: "3", x: 836, y: 559, width: 316, height: 224, rotation: 0, imageRotation: 0 },
        { id: "4", x: 674, y: 66, width: 478, height: 311, rotation: 0, imageRotation: 0 },
        { id: "5", x: 674, y: 385, width: 235, height: 166, rotation: 0, imageRotation: 0 },
        { id: "6", x: 917, y: 385, width: 235, height: 166, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-06",
    name: "PO 06 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_06.png",
    size: [1217, 851],
    style: {},
    slots: [    
        { id: "1", x: 0, y: 268, width: 238, height: 153, rotation: 0, imageRotation: 0 },
        { id: "2", x: 246, y: 268, width: 237, height: 153, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 429, width: 238, height: 153, rotation: 0, imageRotation: 0 },
        { id: "4", x: 246, y: 429, width: 237, height: 153, rotation: 0, imageRotation: 0 },
        { id: "5", x: 491, y: 268, width: 214, height: 314, rotation: 0, imageRotation: 0 },
        { id: "6", x: 713, y: 268, width: 504, height: 314, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-07",
    name: "PO 07 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_07.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 0, y: 201, width: 303, height: 450, rotation: 0, imageRotation: 0 },     
        { id: "2", x: 311, y: 201, width: 177, height: 107, rotation: 0, imageRotation: 0 },
        { id: "3", x: 311, y: 316, width: 177, height: 107, rotation: 0, imageRotation: 0 },
        { id: "4", x: 311, y: 431, width: 177, height: 106, rotation: 0, imageRotation: 0 },
        { id: "5", x: 311, y: 545, width: 177, height: 106, rotation: 0, imageRotation: 0 },
        { id: "6", x: 496, y: 201, width: 720, height: 450, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-08",
    name: "PO 08 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_08.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 62, y: 539, width: 255, height: 173, rotation: 0, imageRotation: 0 },
        { id: "2", x: 62, y: 140, width: 255, height: 391, rotation: 0, imageRotation: 0 },
        { id: "3", x: 325, y: 140, width: 413, height: 282, rotation: 0, imageRotation: 0 },     
        { id: "4", x: 325, y: 430, width: 413, height: 282, rotation: 0, imageRotation: 0 },
        { id: "5", x: 746, y: 140, width: 412, height: 282, rotation: 0, imageRotation: 0 },
        { id: "6", x: 746, y: 430, width: 412, height: 282, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-09",
    name: "PO 09 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_09.png",
    size: [1217, 851],
    style: {},
    slots: [
        { id: "1", x: 62, y: 143, width: 209, height: 306, rotation: 0, imageRotation: 0 },
        { id: "2", x: 279, y: 143, width: 435, height: 306, rotation: 0, imageRotation: 0 },
        { id: "3", x: 722, y: 143, width: 434, height: 306, rotation: 0, imageRotation: 0 },
        { id: "4", x: 62, y: 457, width: 360, height: 251, rotation: 0, imageRotation: 0 },
        { id: "5", x: 430, y: 457, width: 360, height: 251, rotation: 0, imageRotation: 0 },
        { id: "6", x: 798, y: 457, width: 359, height: 251, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h5v1-10",
    name: "PO 10 - H5V1",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h5_v1_10.png",
    size: [1217, 851],
    style: {},
    slots: [  
        { id: "1", x: 76, y: 146, width: 276, height: 181, rotation: 0, imageRotation: 0 },
        { id: "2", x: 76, y: 335, width: 276, height: 181, rotation: 0, imageRotation: 0 },
        { id: "3", x: 76, y: 524, width: 276, height: 181, rotation: 0, imageRotation: 0 },
        { id: "4", x: 360, y: 146, width: 384, height: 559, rotation: 0, imageRotation: 0 },
        { id: "5", x: 752, y: 146, width: 384, height: 276, rotation: 0, imageRotation: 0 },
        { id: "6", x: 752, y: 430, width: 384, height: 275, rotation: 0, imageRotation: 0 }
    ],
}
];